<template>
  <div>
    <div class="main-title">学员列表
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="[1,10].indexOf(user.group_id) >= 0">
            <el-select v-model="searchForm.datefield" style="width:110px;" @change="search(searchParams)">
              <el-option label="训练时间" value="daterange"></el-option>
              <el-option label="退款时间" value="refund_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索驾校/教练/学员/身份证/拼音"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <batch-search @search="batSearch"></batch-search>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.fee_package_id" filterable placeholder="计费方式" style="width:140px;" @change="search(searchParams)">
              <el-option label="全部计费方式" :value="-1"></el-option>
              <el-option label="计时收费" value="0"></el-option>
              <el-option v-for="item in feePackageList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%"
        v-if="user.group_id != 34">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="170">
        </el-table-column>
        <el-table-column
          v-if="user.group_id === 33"
          label="照片"
          width="90">
          <template slot-scope="scope">
            <img v-if="scope.row.face_photo_url" :src="scope.row.face_photo_url" class="student-photo" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip
          v-if="user.group_id==4">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="培训服务"
          width="80"
          v-if="user.group_id == 1">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="类型"
          width="80"
          v-if="user.group_id == 32">
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="110">
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          width="70">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收"
          width="70">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="优惠"
          width="70">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收"
          width="70">
        </el-table-column>
        <el-table-column
          prop="student_fee"
          label="人均"
          width="70">
        </el-table-column>
        <el-table-column
          prop="refund_money"
          label="退款金额"
          width="80"
          v-if="user.group_id == 1">
        </el-table-column>
        <el-table-column
          prop="refund_time"
          label="退款时间"
          width="160"
          v-if="user.group_id == 1">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="训练时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="sales_name"
          label="业务员"
          width="70"
          v-if="[1,10].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip
          v-if="user.group_id!=4">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="180">
          <template slot-scope="scope">
            <el-button type="text" v-if="!scope.row.refund_time && scope.row.is_refund === '是'" @click="refund(scope.row)">点击退款</el-button>
            <el-button type="text" @click="edit(scope.row)">备注</el-button>
            <el-button type="text" style="color: red;" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%"
        v-else>
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          width="80">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="170">
        </el-table-column>
        <el-table-column
          v-if="user.group_id === 33"
          label="照片"
          width="90">
          <template slot-scope="scope">
            <img v-if="scope.row.face_photo_url" :src="scope.row.face_photo_url" class="student-photo" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="驾校"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="80">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="110">
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          width="70">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收"
          width="70">
        </el-table-column>
        <el-table-column
          prop="fee_discount"
          label="优惠"
          width="70">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收"
          width="70">
        </el-table-column>
        <el-table-column
          prop="student_fee"
          label="人均"
          width="70">
        </el-table-column>
        <el-table-column
          prop="bill_no"
          label="单据编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          width="90">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="结束时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="训练时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">备注</el-button>
            <el-button type="text" style="color: red;" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <el-dialog title="退款" :visible.sync="formVisible">
        <el-form :model="form" ref="form" :rules="formRules" label-width="120px">
          <el-form-item label="支出项目" prop="fin_item">
            <el-col :span="11">
              <el-select v-model="form.fin_item" placeholder="请选择项目" style="width:100%">
                <el-option v-for="i in finItemList" :key="i.id" :label="i.item_name" :value="i.item_name"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-input v-model="form.fin_no" placeholder="凭证号(可以不填)" style="width:100%"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="支出金额" prop="fin_money">
            <el-col :span="11">
              <el-input v-model.number="form.fin_money"></el-input>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-input v-model="form.fin_person" placeholder="收款人"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-col :span="11">
              <el-select v-model="form.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
                <el-option label="现金" value="现金"></el-option>
                <el-option label="支付宝" value="支付宝"></el-option>
                <el-option label="微信支付" value="微信支付"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="转账" value="转账"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" style="text-align:center;">-</el-col>
            <el-col :span="11">
              <el-form-item prop="fin_account">
                <el-select v-model="form.fin_account" placeholder="请选择账户" style="width:100%">
                  <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" autosize placeholder="备注(可以不填)"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="commit" :loading="commiting">确 定</el-button>
          <el-button @click="formVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import BatchSearch from './BatchSearch'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  props: {
    user: Object
  },
  components: {
    BatchSearch
  },
  data () {
    return {
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        idcard_guid: '',
        datefield: 'daterange',
        daterange: [
          new Date(),
          new Date()
        ],
        fee_package_id: -1
      },
      form: {
        id: 0,
        fin_type: '0',
        fin_item: '',
        pay_type: '现金',
        fin_account: 0,
        fin_money: 0,
        fin_person: '',
        fin_no: '',
        remark: ''
      },
      formRules: {
        fin_item: [
          { required: true, message: '请选择项目', trigger: 'blur' }
        ],
        fin_account: [
          { required: true, message: '请选择账户', trigger: 'blur' }
        ],
        fin_money: [
          { required: true, message: '请输入金额', trigger: 'blur' }
        ]
      },
      formVisible: false,
      commiting: false,
      finItemList: [],
      accountList: [],
      feePackageList: [],
      studentPhotoLoading: false,
      lastPhotoQueryKey: '',
      sumProps: [
        'refund_money',
        'student_fee'
      ]
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    sqlcode () {
      if (this.user.group_id === 5) {
        return 'student_5'
      } else {
        return 'student'
      }
    },
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          idcard_guid: this.searchForm.idcard_guid,
          fee_package_id: this.searchForm.fee_package_id === -1 ? null : this.searchForm.fee_package_id
        }
      } else {
        let params = {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          idcard_guid: this.searchForm.idcard_guid,
          fee_package_id: this.searchForm.fee_package_id === -1 ? null : this.searchForm.fee_package_id
        }
        params[this.searchForm.datefield + '_start'] = moment(this.searchForm.daterange[0]).format('YYYY-MM-DD')
        params[this.searchForm.datefield + '_end'] = moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        return params
      }
    },
    accountListFilter () {
      if (this.form.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.form.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.form.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.form.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (this.form.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return []
      }
    },
    feePackageListFilter () {
      return this.feePackageList.filter(i => i.is_refund === '是')
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchFinItemList()
    this.fetchAccountList()
    this.fetchFeePackageList()
  },
  watch: {
    list: {
      handler (val) {
        if (this.user.group_id === 33) {
          this.fillStudentPhotos(val)
        }
      },
      deep: false
    }
  },
  methods: {
    fillStudentPhotos (rows) {
      if (!rows || rows.length === 0 || this.studentPhotoLoading) {
        return
      }
      const ids = rows.map(item => item.id).filter(Boolean)
      if (ids.length === 0) {
        return
      }
      const queryKey = ids.join(',')
      const needFetch = rows.some(item => !item.face_photo_url)
      if (!needFetch && this.lastPhotoQueryKey === queryKey) {
        return
      }
      this.studentPhotoLoading = true
      this.lastPhotoQueryKey = queryKey
      this.$http.get('/gate/student/photo-map', {
        params: {
          ids: queryKey
        }
      }).then(response => {
        if (!response.data.success) {
          return
        }
        const photoMap = {}
        for (let i = 0; i < response.data.list.length; i++) {
          photoMap[response.data.list[i].id] = response.data.list[i].face_photo_url
        }
        this.list = this.list.map(item => Object.assign({}, item, {
          face_photo_url: photoMap[item.id] || ''
        }))
      }).finally(() => {
        this.studentPhotoLoading = false
      })
    },
    fetchFeePackageList () {
      this.$http.get('/dbapi/fee_package_list?status=启用').then(response => {
        if (response.data.success) {
          this.feePackageList = response.data.list
        }
      })
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    fetchFinItemList () {
      this.$http.get('/dbapi/fin_item_combo').then(response => {
        if (response.data.success) {
          this.finItemList = response.data.list
          for (var i = 0; i < this.finItemList.length; i++) {
            if (this.finItemList[i].item_name.indexOf('退款') >= 0) {
              this.form.fin_item = this.finItemList[i].item_name
              break;
            }
          }
          if (!this.form.fin_item) {
            this.form.fin_item = '退款'
          }
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          for (var i = 0; i < this.accountList.length; i++) {
            if (this.accountList[i].account_type === '现金') {
              this.form.fin_account = this.accountList[i].id
              break;
            }
          }
        }
      })
    },
    batSearch (guid) { // 批量搜索
      this.searchForm.idcard_guid = guid
      this.search(this.searchParams)
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'price_type') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.form.fin_account = this.accountListFilter[0].id
      }
    },
    refund (row) {
      this.form.id = row.id
      this.form.fin_money = row.student_fee
      this.form.fin_person = row.name
      this.form.remark = '学员:' + row.name + ',单据编号:' + row.bill_no
      this.formVisible = true
    },
    commit: _.throttle(
      function () {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.commiting = true
            this.$http.post('/dbapi/student_refund', this.form).then(response => {
              this.commiting = false
              if (response.data.success) {
                this.formVisible = false
                this.refresh()
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.$confirm('是否要现在打印支出证明单?', '提示', {
                  confirmButtonText: '现在打印',
                  cancelButtonText: '稍后打印',
                  type: 'warning'
                }).then(() => {
                  window.open(this.$http.receiptBaseUrl + '/expend_print?id=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
                })
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      2000
    ),
    edit (row) {
      this.$prompt(`请输入备注`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/student_remark', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_student', { id: row.id }).then(res => {
          if (res.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: "error",
              message: "网络错误，请稍后重试"
            })
            console.log(res)
          }
        })
      })
    }
  }
}
</script>

<style>
.student-photo {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/Student.vue